import React, { useEffect, useState } from "react";
import "./PaymentFailure.css";

export default function PaymentFailure(){

  const [loading,setLoading] = useState(true);
  const [pedido,setPedido] = useState(null);

  const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzRpTEbdM6dzZwK7v_48aEJjNVivn-auestSaWDHNebj8kI73yW2CE9aZMihb8Wt-_g/exec";

  useEffect(()=>{

    const params = new URLSearchParams(window.location.search);

    const pedido_id = params.get("external_reference");
    const status = params.get("status");

    setPedido(pedido_id);

    if(!pedido_id){
      setLoading(false);
      return;
    }

    fetch(SCRIPT_URL,{
      method:"POST",
      body:new URLSearchParams({
        pedido_id:pedido_id,
        status:status || "rejected"
      })
    })
    .then(()=>setLoading(false))
    .catch(()=>setLoading(false));

  },[]);


  return(

    <div className="payment-failure-page">

      <div className="payment-failure-card">

        <div className="icon">
          ✕
        </div>

        <h1>Pagamento não aprovado</h1>

        <p>
          Infelizmente não foi possível processar o pagamento.
        </p>

        {pedido && (
          <p className="pedido">
            Pedido: <strong>{pedido}</strong>
          </p>
        )}

        {loading && (
          <div className="loader"/>
        )}

        {!loading && (
          <p className="status">
            Nada foi debitado da sua conta. É seguro tentar novamente.
          </p>
        )}

        <button
          className="btn"
          onClick={()=>window.location.href="/"}
        >
          Tentar novamente
        </button>

      </div>

    </div>

  )

}